import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { TbFileExport } from "react-icons/tb";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoEyeOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import { TbCubePlus } from "react-icons/tb";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { MdDeleteOutline } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

import "./Inventory.css";
import "../Dashboard/Dashboard.css";
import productImg from "../../../assets/images/State-Distributor/inventoryProduct.png";
import placeholderImg from "../../../assets/images/previewPlaceholder.png";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import TablePagination from "@mui/material/TablePagination";
import { AiOutlineDelete } from "react-icons/ai";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import * as yup from "yup";
import * as XLSX from "xlsx";

let addProductSchema = yup.object({
  product_image: yup
    .mixed()
    .required("Product image is required")
    .test(
      "fileType",
      "Only PNG, JPG, and JPEG images are allowed",
      (file) =>
        file && ["image/png", "image/jpg", "image/jpeg"].includes(file.type),
    ),

  upload_image: yup
    .array()
    .max(3, "You can upload up to 3 images only")
    .of(
      yup
        .mixed()
        .test(
          "fileType",
          "Only PNG, JPG, and JPEG images are allowed",
          (file) =>
            file &&
            ["image/png", "image/jpg", "image/jpeg"].includes(file.type),
        ),
    ),

  product_name: yup.string().required("Product Name is required"),
  product_code: yup.string().required("Product code is required"),
  category: yup.string().required("Category is required"),
  uom: yup.string().required("UOM is required"),
  default_cost_price: yup.number().required("Default cost price is required"),
  subdistributor_selling_price: yup
    .number()
    .required("Subdistributor price is required"),
  retail_selling_price: yup
    .number()
    .required("Retail selling price is required"),
});

let editProductSchema = yup.object({
  product_image: yup
    .mixed()
    // .required("Product image is required")
    .nullable()
    .test("fileType", "Only PNG, JPG, and JPEG images are allowed", (file) => {
      if (!file) return true; // allow null / unchanged image
      return ["image/png", "image/jpg", "image/jpeg"].includes(file.type);
    }),

  upload_image: yup
    .array()
    .max(3, "You can upload up to 3 images only")
    .of(
      yup
        .mixed()
        .test(
          "fileType",
          "Only PNG, JPG, and JPEG images are allowed",
          (file) =>
            file &&
            ["image/png", "image/jpg", "image/jpeg"].includes(file.type),
        ),
    ),
  product_name: yup.string().required("Product Name is required"),
  product_code: yup.string().required("Product code is required"),
  category: yup.string().required("Category is required"),
  uom: yup.string().required("UOM is required"),
  default_cost_price: yup.number().required("Default cost price is required"),
  subdistributor_selling_price: yup
    .number()
    .required("Subdistributor price is required"),
  retail_selling_price: yup
    .number()
    .required("Retail selling price is required"),
});

export const Inventory = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [activeMenu, setactiveMenu] = useState("allProducts");

  const [allProducts, setAllProducts] = useState({});
  const [lowStockProducts, setlowStockProducts] = useState({});
  const [productCode, setProductCode] = useState();

  function handleSelectMenu(menu) {
    setactiveMenu(menu);
  }

  // add product modal
  const [addshow, setAddShow] = useState(false);

  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);
  // add category modal
  const [categoryshow, setCategoryShow] = useState(false);

  const handleCategoryClose = () => setCategoryShow(false);
  const handleCategoryShow = () => {
    setCategoryShow(true);
    handleAddClose();
  };
  // add uom modal
  const [uomshow, setUomShow] = useState(false);

  const handleUomClose = () => setUomShow(false);
  const handleUomShow = () => {
    setUomShow(true);
    handleAddClose();
  };
  // add variant
  const [variantshow, setVariantShow] = useState(false);

  const handleVariantClose = () => setVariantShow(false);
  const handleVariantShow = () => {
    setVariantShow(true);
    handleAddClose();
  };

  // edit product modal
  const [editshow, setEditShow] = useState(false);

  const handleEditClose = () => setEditShow(false);
  const handleEditShow = (id) => {
    setEditShow(true);
    setProductCode(id);
    LoadSingleProduct(id);
  };
  const [allPage, setAllPage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_inventory_all_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [allRowsPerPage, setAllRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_inventory_all_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [allTotalCount, setAllTotalCount] = useState(0);

  const handleAllRowsPerPage = (event) => {
    setAllRowsPerPage(+event.target.value);
    setAllPage(0);
    sessionStorage.setItem(
      "dis_inventory_all_rowsPerPage",
      +event.target.value,
    );
    sessionStorage.setItem("dis_inventory_all_page", 0);
  };

  // Filters
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);
  const [categoryToggler, setCategoryToggler] = useState("");
  const [searchText, setSearchText] = useState(""); // product name
  const [sortBy, setSortBy] = useState(""); // sort_by field

  async function FetchAllProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: allPage + 1,
          page_size: allRowsPerPage,
          search: searchText,
          category: categoryToggler,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/distributor/products/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setAllProducts(response.data.data);
        setAllTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch all products",
      );
      console.log("Failed to fetch all products");
    } finally {
      setLoading(false);
    }
  }
useEffect(() => {
  FetchAllProducts();
}, [allPage, allRowsPerPage]);

useEffect(() => {
  const delayDebounce = setTimeout(() => {
    if (allPage !== 0) {
      setAllPage(0);
    } else {
      FetchAllProducts();
    }

    setLowPage(0);
  }, 500);

  return () => clearTimeout(delayDebounce);
}, [
  categoryToggler,
  searchText,
  selectedLabel,
  sortBy,
]);


  const [lowPage, setLowPage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_inventory_low_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [lowRowsPerPage, setLowRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_inventory_low_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [lowTotalCount, setLowTotalCount] = useState(0);

  const handleLowRowsPerPage = (event) => {
    setLowRowsPerPage(+event.target.value);
    setLowPage(0);
    sessionStorage.setItem(
      "dis_inventory_low_rowsPerPage",
      +event.target.value,
    );
    sessionStorage.setItem("dis_inventory_low_page", 0);
  };

  async function FetchLowStockProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: lowPage + 1,
          page_size: lowRowsPerPage,
          search: searchText,
          category: categoryToggler,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/distributor/product-low-stock/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setlowStockProducts(response.data.data);
        setLowTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch Low Stock products",
      );
      console.log("Failed to fetch Low Stock products");
    } finally {
      setLoading(false);
    }
  }
  useEffect(()=>{
    FetchLowStockProducts();
  },[ lowPage,
    lowRowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
       if (lowPage !== 0){
        setLowPage(0);
      }else{
        FetchLowStockProducts();
      }
      
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [
   
    categoryToggler,
    searchText,
    selectedLabel,
    sortBy,
  ]);
  const handleClearFilters = () => {
    setSearchText("");
    setCategoryToggler("");
    setSelectedLabel("");
    setSortBy("");

    // reset pages
    // setAllPage(0);
    // setLowPage(0);

    // fetch fresh data based on active tab
    // if (activeMenu === "allProducts") FetchAllProducts();
    // else FetchLowStockProducts();
  };

  const handleReset = () => {
    // handleClearFilters();
    // setAllRowsPerPage(10);
    setSearchText("");
  };

  const formik = useFormik({
    initialValues: {
      product_image: null,
      upload_image: [],
      product_name: "",
      color: "",
      variant: "",
      product_code: "",
      category: "",
      min_stock_level: "",
      default_cost_price: "",
      subdistributor_selling_price: "",
      retail_selling_price: "",
      uom: "",
      isi_code: "",
      package_size: "",
      hs_code: "",
      points: "",
      points_uom: "",
      percentage: "",
      features: "",
      description: "",
      additional_notes: "",
    },
    validationSchema: addProductSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("product_image", values.product_image);
        values.upload_image.forEach((file) => {
          formData.append("upload_image", file);
        });
        formData.append("product_name", values.product_name);
        formData.append("color", values.color);
        formData.append("variant", values.variant);
        formData.append("product_code", values.product_code);
        formData.append("category", values.category);
        formData.append("min_stock_level", values.min_stock_level);
        formData.append("default_cost_price", values.default_cost_price);
        formData.append(
          "subdistributor_selling_price",
          values.subdistributor_selling_price,
        );
        formData.append("retail_selling_price", values.retail_selling_price);
        formData.append("uom", values.uom);

        formData.append("isi_code", values.isi_code);
        formData.append("package_size", values.package_size);
        formData.append("hs_code", values.hs_code);
        formData.append("points", values.points);
        formData.append("points_uom", values.points_uom);
        formData.append("percentage", values.percentage);
        formData.append("features", values.features);
        formData.append("description", values.description);

        formData.append("additional_notes", values.additional_notes);

        const response = await axiosInstance.post(
          "/inventory/distributor/products/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.data.status === "Success" || response.status === 200) {
          toast.success(response.data.message || "Product addded successfully");
          FetchAllProducts();
          resetForm();
          handleAddClose();
        }
      } catch (error) {
        toast.error("Failed to add product");
        console.log("Failed to add product");
      } finally {
        setLoading(false);
      }
    },
  });
  const editformik = useFormik({
    initialValues: {
      product_image: null,
      upload_image: [],
      product_name: "",
      color: "",
      variant: "",
      product_code: "",
      category: "",
      min_stock_level: "",
      default_cost_price: "",
      subdistributor_selling_price: "",
      retail_selling_price: "",
      uom: "",
      isi_code: "",
      package_size: "",
      hs_code: "",
      points: "",
      points_uom: "",
      percentage: "",
      features: "",
      description: "",
      additional_notes: "",
    },
    validationSchema: editProductSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const formData = new FormData();
        // formData.append("product_image", values.product_image);
        // only send new file
        if (values.product_image instanceof File) {
          formData.append("product_image", values.product_image);
        }
        if (
          Array.isArray(values.upload_image) &&
          values.upload_image.length > 0
        ) {
          values.upload_image.forEach((file) => {
            if (file instanceof File) {
              formData.append("upload_image", file);
            }
          });
        }

        formData.append("product_name", values.product_name);
        formData.append("color", values.color);
        formData.append("variant", values.variant);
        formData.append("product_code", values.product_code);
        formData.append("category", values.category);
        formData.append("min_stock_level", values.min_stock_level);

        formData.append("default_cost_price", values.default_cost_price);
        formData.append(
          "subdistributor_selling_price",
          values.subdistributor_selling_price,
        );
        formData.append("retail_selling_price", values.retail_selling_price);
        formData.append("uom", values.uom);

        formData.append("isi_code", values.isi_code);
        formData.append("package_size", values.package_size);
        formData.append("hs_code", values.hs_code);
        formData.append("points", values.points);
        formData.append("points_uom", values.points_uom);
        formData.append("percentage", values.percentage);
        formData.append("features", values.features);
        formData.append("description", values.description);

        formData.append("additional_notes", values.additional_notes);

        const response = await axiosInstance.patch(
          `inventory/product/${productCode}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.data.status === "success" || response.status === 200) {
          toast.success(response.data.message || "Product edited successfully");
          FetchAllProducts();
          resetForm();
          handleEditClose();
        }
      } catch (error) {
        toast.error("Failed to edit product");
        console.log("Failed to edit product");
      } finally {
        setLoading(false);
      }
    },
  });

  const [previews, setPreviews] = useState({
    product_image: null,
  });
  const [additionPreviews, setAdditionalPreviews] = useState({
    images: [],
  });
  // edit single product get
  async function LoadSingleProduct(id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/inventory/product/${id}`);
      if (response.data.status === "success" || response.status === 200) {
        // editformik.setValues(response.data.data);
        editformik.setValues({
          product_image: null,
          upload_image: [],
          product_name: response.data.data.product_name || "",
          color: response.data.data.color || "",
          variant: response.data.data.variant || "",
          product_code: response.data.data.product_code || "",
          category: response.data.data.category || "",
          min_stock_level: response.data.data.min_stock_level || "",
          default_cost_price: response.data.data.default_cost_price || "",
          subdistributor_selling_price:
            response.data.data.subdistributor_selling_price || "",
          retail_selling_price: response.data.data.retail_selling_price || "",
          uom: response.data.data.uom || "",
          isi_code: response.data.data.isi_code || "",
          package_size: response.data.data.package_size || "",
          hs_code: response.data.data.hs_code || "",
          points: response.data.data.points || "",
          points_uom: response.data.data.points_uom || "",
          percentage: response.data.data.percentage || "",
          features: response.data.data.features || "",
          description: response.data.data.description || "",
          additional_notes: response.data.data.additional_notes || "",
        });

        setPreviews({
          product_image: response.data.data.product_image || null,
        });
        setAdditionalPreviews({
          images: response.data.data.images || [],
        });
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load product data");
    } finally {
      setLoading(false);
    }
  }
  //category
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  async function LoadCategoryDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/category/");
      if (response.data.status === "Success" || response.status === 200) {
        setCategoryDropdown(response.data.data);
        console.log("category dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch category dropdown",
      );
      console.log("Failed to fetch category dropdown");
    }
  }
  useEffect(() => {
    LoadCategoryDropdown();
  }, []);

  const [newCategory, setNewCategory] = useState("");

  async function handleCategorySubmit() {
    try {
      setLoading(true);
      const payload = {
        name: newCategory,
      };
      const response = await axiosInstance.post(
        "/inventory/category/",
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        handleCategoryClose();
        LoadCategoryDropdown();
        handleAddShow();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit category");
      console.log("Failed to submit category");
    } finally {
      setLoading(false);
    }
  }
  // variant
  const [variantDropdown, setVariantDropdown] = useState([]);

  async function LoadVariantDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/product-variant/");
      if (response.data.status === "Success" || response.status === 200) {
        setVariantDropdown(response.data.data);
        console.log("variant dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch variant dropdown",
      );
      console.log("Failed to fetch variant dropdown");
    }
  }
  useEffect(() => {
    LoadVariantDropdown();
  }, []);

  const [newVariant, setNewVariant] = useState("");

  async function handleVariantSubmit() {
    try {
      setLoading(true);
      const payload = {
        code: newVariant,
      };
      const response = await axiosInstance.post(
        "/inventory/product-variant/",
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        handleVariantClose();
        LoadVariantDropdown();
        handleAddShow();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit variant");
      console.log("Failed to submit variant");
    } finally {
      setLoading(false);
    }
  }
  //uom
  const [uomDropdown, setUomDropdown] = useState([]);

  async function LoadUomDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/uom/");
      if (response.data.status === "Success" || response.status === 200) {
        setUomDropdown(response.data?.data);
        console.log("uom dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch uom dropdown",
      );
      console.log("Failed to fetch uom dropdown");
    }
  }
  useEffect(() => {
    LoadUomDropdown();
  }, []);
  const [newUom, setNewUom] = useState("");

  async function handleUomSubmit() {
    try {
      setLoading(true);
      const payload = {
        name: newUom,
      };
      const response = await axiosInstance.post("/inventory/uom/", payload);
      if (response.data.status === "Success" || response.status === 200) {
        handleUomClose();
        LoadUomDropdown();
        handleAddShow();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to submit uom");
      console.log("Failed to submit uom");
    } finally {
      setLoading(false);
    }
  }

  // all products and low products delete modal state
  const [deleteId, setDeleteId] = useState();
  const [deleteshow, setDeleteShow] = useState(false);

  const handleDeleteClose = () => setDeleteShow(false);
  const handleDeleteShow = (id) => {
    setDeleteShow(true);
    setDeleteId(id);
  };

  async function handleDeleteProduct() {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `/inventory/distributor/product-delete/${deleteId}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Deleted successfully");
        console.log("Deleted successfully");
        handleDeleteClose();
        FetchAllProducts();
        FetchLowStockProducts();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to delete");
      console.log("Failed to delete");
    }
  }

  // ref wise table
  const [refTableData, setRefTableData] = useState([]);
  const [refTablePage, setRefTablePage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_inventory_ref_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [refTableRowsPerPage, setRefTableRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_inventory_ref_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [refTableTotalCount, setRefTableTotalCount] = useState(0);
  const [refDateFilter, setRefDateFilter] = useState("");

  const handleRefTableRowsPerPage = (event) => {
    setRefTableRowsPerPage(+event.target.value);
    setRefTablePage(0);
    sessionStorage.setItem(
      "dis_inventory_ref_rowsPerPage",
      +event.target.value,
    );
    sessionStorage.setItem("dis_inventory_ref_page", 0);
  };

  async function FetchRefwiseProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: refTablePage + 1,
          page_size: refTableRowsPerPage,
          date: refDateFilter,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/distributor/incoming-stock-list/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setRefTableData(response.data.data);
        setRefTableTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch Added Stock products",
      );
      console.log("Failed to fetch Low Stock products");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      FetchRefwiseProducts();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [refTablePage, refTableRowsPerPage, refDateFilter]);

  function handleClearRefFilters() {
    setRefDateFilter("");
    FetchRefwiseProducts();
  }
  // ref wise stock delete modal state
  const [deleteStockId, setDeleteStockId] = useState();
  const [deleteStockshow, setDeleteStockShow] = useState(false);

  const handleDeleteStockClose = () => setDeleteStockShow(false);
  const handleDeleteStockShow = (id) => {
    setDeleteStockShow(true);
    setDeleteStockId(id);
  };
  async function handleDeleteStock() {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `/inventory/distributor/incoming-stock-item-update/${deleteStockId}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Deleted successfully");
        console.log("Deleted successfully");
        handleDeleteStockClose();
        FetchRefwiseProducts();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to delete");
      console.log("Failed to delete");
    } finally {
      setLoading(false);
    }
  }
  async function handleExport() {
    try {
      setLoading(true);

      let url = "";
      let defaultFileName = "export.xlsx";

      if (activeMenu === "allProducts") {
        url = "/inventory/distributor/product-export/";
        defaultFileName = "all_products.xlsx";
      } else if (activeMenu === "low") {
        url = "/inventory/distributor/low-stock-excel/";
        defaultFileName = "low_stock.xlsx";
      } else {
        return;
      }

      const response = await axiosInstance.get(url, {
        responseType: "blob",
      });

      if (response.status === 200) {
        // const blob = new Blob([response.data], { type: "application/pdf" });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        // const contentDisposition = response.headers["content-disposition"];
        // let fileName = "invoice.pdf";
        // // let fileName;
        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?(.+)"?/);
        //   if (match && match[1]) fileName = match[1];
        // }

        const contentDisposition = response.headers["content-disposition"];
        let fileName = defaultFileName;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            fileName = match[1].endsWith(".xlsx")
              ? match[1]
              : `${match[1]}.xlsx`;
          }
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      let errorMessage = "Failed to export";

      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errorMessage = json.message || errorMessage;
        } catch (e) {
          // fallback if parsing fails
        }
      } else {
        errorMessage = error.response?.data?.message || errorMessage;
      }

      toast.error(errorMessage);
      console.error("Export failed", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Inventory Management</div>
              <div className="inventorySubtitle">
                Manage stock inflow, outflow, and product availability in
                real-time.
              </div>
            </div>
            <div className="addButtonContainer">
              {/* <div className="inventoryBtnReorder">
                <button onClick={()=>navigate("/view-all-products")}>View</button>
              </div> */}
              <div className="inventoryBtnPro">
                <button onClick={handleAddShow}>Add Product</button>
              </div>
              <div className="inventoryBtnReorder">
                <button
                  onClick={() => navigate("/state-inventory-bulkReorder")}
                  disabled
                >
                  Re-Order
                </button>
              </div>

              <div className="inventoryBtnIncome">
                <button
                  onClick={() =>
                    navigate("/state-inventory-bulkAddIncomeStock")
                  }
                >
                  Add Incoming Stock
                </button>
              </div>
            </div>
          </div>

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Product Name, Product Code"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Product Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {categoryToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setCategoryToggler("")}>
                      All
                    </Dropdown.Item>
                    {categoryDropdown?.map((cat) => (
                      <Dropdown.Item
                        onClick={() => setCategoryToggler(cat.name)}
                      >
                        {cat.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {/* {(categoryToggler || selectedLabel) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of
                </span>{" "}
                : &nbsp; {categoryToggler ? categoryToggler : ""}
                {selectedLabel ? `, ${selectedLabel}` : ""}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                {" "}
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )} */}

          {(searchText || categoryToggler || selectedLabel || sortBy) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Product:</strong> {searchText}{" "}
                  </>
                )}

                {categoryToggler && categoryToggler !== "All" && (
                  <>
                    {" "}
                    , <strong>Category:</strong> {categoryToggler}{" "}
                  </>
                )}

                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}

                {sortBy && (
                  <>
                    {" "}
                    , <strong>Sorted By:</strong>{" "}
                    {sortBy.replace("_", " ")}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          {/* cards section  */}
          <div className="inventoryCardsGrid">
            <div className="inventoryCard">
              <div>Total Stock Quantity</div>
              <div>{allProducts?.product_card?.total_stock_quantity}</div>
            </div>
            <div className="inventoryCard">
              <div>Total Stock Value (₹)</div>
              <div>{allProducts?.product_card?.total_stock_value}</div>
            </div>
            <div className="inventoryCard">
              <div>Low Stock Products</div>
              <div>{allProducts?.product_card?.low_stock_count}</div>
            </div>
          </div>
          {/* table menu  */}
          <div className="inventoryFilterContainer">
            <div className="inventoryMenu">
              <div
                onClick={() => handleSelectMenu("allProducts")}
                className={`menuTitle ${
                  activeMenu === "allProducts" ? "active" : ""
                }`}
              >
                All Products
              </div>
              <div
                onClick={() => handleSelectMenu("low")}
                className={`menuTitle ${activeMenu === "low" ? "active" : ""}`}
              >
                Low Stock
              </div>
            </div>
            <div className="inventoryFilters">
              <div className="inventoryBtnExport">
                <button onClick={handleExport}>
                  Export{" "}
                  <span>
                    <TbFileExport />
                  </span>
                </button>
              </div>
              {/* <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    Sort by
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>Stock Value</Dropdown.Item>
                    <Dropdown.Item>Avl.Qty</Dropdown.Item>
                    <Dropdown.Item>Last Import</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}
              <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {sortBy || "Select"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setSortBy("stock_value")}>
                      Stock Value
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setSortBy("avl_qty")}>
                      Avl.Qty
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setSortBy("last_import")}>
                      Last Import
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          {activeMenu === "allProducts" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 1200 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Product Image</TableCell>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Product Code</TableCell>
                      <TableCell align="left">Category</TableCell>
                      <TableCell align="left">UOM</TableCell>
                      <TableCell align="left">Avl. Qty</TableCell>
                      <TableCell align="left">Package Size</TableCell>
                      <TableCell align="left">Last Import</TableCell>
                      <TableCell align="left">Stock Value (₹)</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allProducts?.results?.length > 0 ? (
                      allProducts?.results?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell align="left">
                            <span className="productImg">
                              <img
                                src={
                                  row.product_image
                                    ? row.product_image
                                    : placeholderImg
                                }
                              />
                            </span>
                          </TableCell>
                          <TableCell align="left">{row.product_name}</TableCell>
                          <TableCell align="left">{row.product_code}</TableCell>
                          <TableCell align="left">{row.category}</TableCell>
                          <TableCell align="left">{row.uom}</TableCell>
                          <TableCell align="left">
                            {row.current_stock}
                          </TableCell>
                          <TableCell align="left">{row.package_size}</TableCell>
                          <TableCell align="left">
                            {row.last_import || "---"}
                          </TableCell>
                          <TableCell align="left">{row.stock_value}</TableCell>

                          <TableCell
                            align="left"
                            style={{
                              color: (() => {
                                switch (row.status) {
                                  case "Low Stock":
                                    return "#F59E0B";
                                  case "Normal":
                                    return "#10B981";
                                  default:
                                    return "var(--color-font-secondary)";
                                }
                              })(),
                            }}
                          >
                            {row.status}
                          </TableCell>

                          <TableCell align="left">
                            <div className="d-flex gap-3">
                              <span
                                onClick={() =>
                                  navigate("/state-inventory-view", {
                                    state: {
                                      Id: row.id,
                                      productCode: row.product_code,
                                    },
                                  })
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <IoEyeOutline />
                              </span>
                              <span
                                onClick={() => handleEditShow(row.id)}
                                style={{ cursor: "pointer" }}
                              >
                                <FiEdit />
                              </span>
                              <span onClick={() => handleDeleteShow(row.id)}>
                                <AiOutlineDelete />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={11}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={allTotalCount}
                page={allPage}
                onPageChange={(event, newPage) => {
                  setAllPage(newPage);
                  sessionStorage.setItem("dis_inventory_all_page", newPage);
                }}
                rowsPerPage={allRowsPerPage}
                onRowsPerPageChange={handleAllRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}
          {activeMenu === "low" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 1200 }}

                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Product Image</TableCell>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Product Code</TableCell>
                      <TableCell align="left">Category</TableCell>
                      <TableCell align="left">Avl. Qty</TableCell>
                      <TableCell align="left">Min. Stock Level</TableCell>
                      <TableCell align="left">Last Import</TableCell>

                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {lowStockProducts?.results?.length > 0 ? (
                      lowStockProducts?.results?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          {/* Product Image */}
                          <TableCell align="left">
                            <span className="productImg">
                              <img
                                src={
                                  row.product_image
                                    ? row.product_image
                                    : placeholderImg
                                }
                                alt="product"
                                style={{ width: 40, height: 40 }}
                              />
                            </span>
                          </TableCell>

                          <TableCell>{row.product_name}</TableCell>
                          <TableCell>{row.product_code}</TableCell>
                          <TableCell>{row.category}</TableCell>

                          <TableCell>{row.current_stock}</TableCell>

                          <TableCell>{row.min_stock_level}</TableCell>

                          <TableCell>{row.last_import || "---"}</TableCell>

                          {/* Actions */}
                          <TableCell align="left">
                            <div className="d-flex gap-3">
                              <span
                                onClick={() =>
                                  navigate("/state-inventory-view", {
                                    state: {
                                      Id: row.id,
                                      productCode: row.product_code,
                                    },
                                  })
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <IoEyeOutline />
                              </span>

                              <span
                                onClick={() => handleEditShow(row.id)}
                                style={{ cursor: "pointer" }}
                              >
                                <FiEdit />
                              </span>
                              <span onClick={() => handleDeleteShow(row.id)}>
                                <AiOutlineDelete />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          {loading ? "Loading..." : "No Low Stock Products"}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={lowTotalCount}
                page={lowPage}
                onPageChange={(event, newPage) => {
                  setLowPage(newPage);
                  sessionStorage.setItem("dis_inventory_low_page", newPage);
                }}
                rowsPerPage={lowRowsPerPage}
                onRowsPerPageChange={handleLowRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}
          {/* Ref wise table */}

          <div className="d-flex justify-content-between">
            <div className="titleOrderList">Added Stock</div>
            <div>
              <input
                type="date"
                className="dateInput"
                value={refDateFilter}
                onChange={(e) => setRefDateFilter(e.target.value)}
              />
            </div>

            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Date"
                // value={date}
                // onChange={(newValue) => setDate(newValue)}
                slotProps={{
                  textField: {
                    size: "small", //reduces height
                    sx: {
                      width: 160,
                      "& .MuiInputBase-root": {
                        height: 36,
                        fontSize: "13px",
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider> */}
          </div>

          {refDateFilter && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {refDateFilter && (
                  <>
                    {" "}
                    &nbsp; <strong>Date:</strong> {refDateFilter}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearRefFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}

                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Reference No.</TableCell>
                    <TableCell align="left">Date</TableCell>

                    <TableCell align="left">Qty Received</TableCell>
                    <TableCell align="left">Stock Value</TableCell>

                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {refTableData?.results?.length > 0 ? (
                    refTableData?.results?.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell>{row.reference_no}</TableCell>
                        <TableCell>{row.received_date}</TableCell>
                        <TableCell>{row.qty}</TableCell>
                        <TableCell>{row.stock_value}</TableCell>

                        {/* Actions */}
                        <TableCell align="left">
                          <div className="d-flex gap-3">
                            {/* <span
                              onClick={() =>
                                navigate("/state-inventory-view", {
                                  state: {
                                    Id: row.id,
                                    productCode: row.product_code,
                                  },
                                })
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <IoEyeOutline />
                            </span> */}

                            <span
                              onClick={() =>
                                navigate("/state-edit-refwise-stock", {
                                  state: {
                                    Id: row.id,
                                  },
                                })
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <FiEdit />
                            </span>
                            <span onClick={() => handleDeleteStockShow(row.id)}>
                              <AiOutlineDelete />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        {loading ? "Loading..." : "Data Not Available"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={refTableTotalCount}
              page={refTablePage}
              onPageChange={(event, newPage) => {
                setRefTablePage(newPage);
                sessionStorage.setItem("dis_inventory_ref_page", newPage);
              }}
              rowsPerPage={refTableRowsPerPage}
              onRowsPerPageChange={handleRefTableRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </div>
          {/* add product modal  */}
          <div>
            <Modal
              show={addshow}
              onHide={handleAddClose}
              centered
              size="lg"
              className="addModal"
            >
              <form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title className="addModalTitle">
                    Add New Product
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Product Image <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        name="product_image"
                        accept=".png,.jpg,.jpeg"
                        onChange={(e) => {
                          formik.setFieldValue(
                            "product_image",
                            e.currentTarget.files[0],
                          );
                          console.log(
                            "Selected file:",
                            e.currentTarget.files[0],
                          );
                        }}
                      />
                      {formik.values.product_image && (
                        <div>
                          <img
                            src={URL.createObjectURL(
                              formik.values.product_image,
                            )}
                            alt="preview"
                            width={80}
                            style={{ marginRight: 8 }}
                          />
                        </div>
                      )}

                      {formik.errors.product_image &&
                        formik.touched.product_image && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.product_image}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>Additional Images (add up to 3)</label>
                      <input
                        type="file"
                        name="upload_image"
                        multiple
                        accept=".png,.jpg,.jpeg"
                        // onChange={(e) => {
                        //   const files = Array.from(e.currentTarget.files);

                        //   formik.setFieldValue("upload_image", files);
                        //   console.log("Selected files:", files);
                        // }}
                        onChange={(e) => {
                          const newFiles = Array.from(e.currentTarget.files);
                          const existingFiles =
                            formik.values.upload_image || [];

                          const combinedFiles = [...existingFiles, ...newFiles];

                          //  does not allow 4th image
                          if (combinedFiles.length > 3) {
                            formik.setTouched("upload_image", true);
                            formik.setErrors(
                              "upload_image",
                              "You can upload a maximum of 3 images",
                            );
                            e.target.value = "";
                            return;
                          }

                          // clear error if valid
                          formik.setFieldError("upload_image", undefined);
                          formik.setFieldValue("upload_image", combinedFiles);
                          e.target.value = "";
                        }}
                      />
                      {formik.values.upload_image.length > 0 && (
                        <div>
                          {formik.values.upload_image.map((file, index) => (
                            <img
                              key={index}
                              src={URL.createObjectURL(file)}
                              alt="preview"
                              className="mt-3"
                              width={80}
                              style={{ marginRight: 8 }}
                            />
                          ))}
                        </div>
                      )}

                      {formik.errors.upload_image &&
                        formik.touched.upload_image && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.upload_image}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Product Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Product Name"
                        name="product_name"
                        value={formik.values.product_name}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.product_name &&
                        formik.touched.product_name && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.product_name}
                          </div>
                        )}
                    </div>

                    <div>
                      <label>Color</label>
                      <input
                        type="text"
                        placeholder="Enter Color"
                        name="color"
                        value={formik.values.color}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Product Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Product Code"
                        name="product_code"
                        value={formik.values.product_code}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.product_code &&
                        formik.touched.product_code && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.product_code}
                          </div>
                        )}
                    </div>
                    <div>
                      <div className="d-flex justify-content-between">
                        <label>Variant</label>
                        <div
                          onClick={handleVariantShow}
                          className="addCategoryText"
                        >
                          Add Variant
                        </div>
                      </div>
                      <select
                        onChange={formik.handleChange}
                        name="variant"
                        value={formik.values.variant}
                      >
                        <option value={""} selected disabled>
                          Select Variant
                        </option>

                        {variantDropdown.length > 0 ? (
                          variantDropdown.map((variant, index) => (
                            <option key={index} value={variant.code}>
                              {variant.code}
                            </option>
                          ))
                        ) : (
                          <option disabled>Data not available</option>
                        )}
                      </select>
                      {formik.errors.variant && formik.touched.variant && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.variant}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="addModalGrid">
                    <div>
                      <div className="d-flex justify-content-between">
                        <label>
                          Category <span className="text-danger">*</span>
                        </label>
                        <div
                          onClick={handleCategoryShow}
                          className="addCategoryText"
                        >
                          Add Category
                        </div>
                      </div>
                      <select
                        onChange={formik.handleChange}
                        name="category"
                        value={formik.values.category}
                      >
                        <option value={""} selected disabled>
                          Select Category
                        </option>

                        {categoryDropdown.length > 0 ? (
                          categoryDropdown.map((cat) => (
                            <option value={cat.name}>{cat.name}</option>
                          ))
                        ) : (
                          <option>Data not available</option>
                        )}
                      </select>
                      {formik.errors.category && formik.touched.category && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.category}
                        </div>
                      )}
                    </div>
                    <div>
                      <label>Min Stock Level</label>
                      <input
                        type="number"
                        placeholder="Enter min stock level"
                        name="min_stock_level"
                        value={formik.values.min_stock_level}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Default Cost Price (MRP)(₹){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Enter Price"
                        name="default_cost_price"
                        value={formik.values.default_cost_price}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.default_cost_price &&
                        formik.touched.default_cost_price && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.default_cost_price}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>
                        Sub-distributor Selling Price{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Enter Selling Price"
                        name="subdistributor_selling_price"
                        value={formik.values.subdistributor_selling_price}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.subdistributor_selling_price &&
                        formik.touched.subdistributor_selling_price && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.subdistributor_selling_price}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Retail Selling Price{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Enter Selling Price"
                        name="retail_selling_price"
                        value={formik.values.retail_selling_price}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.retail_selling_price &&
                        formik.touched.retail_selling_price && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.retail_selling_price}
                          </div>
                        )}
                    </div>
                    <div>
                      <div className="d-flex justify-content-between">
                        <label>
                          Unit of Measure <span className="text-danger">*</span>
                        </label>
                        <div
                          onClick={handleUomShow}
                          className="addCategoryText"
                        >
                          Add UOM
                        </div>
                      </div>
                      <select
                        onChange={formik.handleChange}
                        name="uom"
                        value={formik.values.uom}
                      >
                        <option value={""} selected disabled>
                          Select UOM
                        </option>

                        {uomDropdown.length > 0 ? (
                          uomDropdown.map((uom) => (
                            <option value={uom.name}>{uom.name}</option>
                          ))
                        ) : (
                          <option>Data not available</option>
                        )}
                      </select>
                      {formik.errors.uom && formik.touched.uom && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.uom}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="addModalGrid">
                    <div>
                      <label>ISI Code</label>
                      <input
                        type="text"
                        placeholder="Enter ISI Code"
                        name="isi_code"
                        value={formik.values.isi_code}
                        onChange={formik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Package Size</label>
                      <input
                        type="text"
                        placeholder="Enter Package Size"
                        name="package_size"
                        value={formik.values.package_size}
                        onChange={formik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>HS Code</label>
                      <input
                        type="text"
                        placeholder="Enter HS Code"
                        name="hs_code"
                        value={formik.values.hs_code}
                        onChange={formik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Features</label>
                      <input
                        type="text"
                        placeholder="Enter Features"
                        name="features"
                        value={formik.values.features}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.features && formik.touched.features && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.features}
                        </div>
                      )}
                    </div>
                    {/* <div>
                      <label>Color</label>
                      <input
                        type="text"
                        placeholder="Enter Color"
                        name="color"
                        value={formik.values.color}
                        onChange={formik.handleChange}
                      />
                    </div> */}
                    {/* <div>
                      <label>Transportation Cost</label>
                      <input
                        type="text"
                        placeholder="Enter Transportation Cost"
                        // name=""
                        // value={formik.values.retail_selling_price}
                        // onChange={formik.handleChange}
                      />
                    </div> */}
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>Points</label>
                      <input
                        type="text"
                        placeholder="Enter Points"
                        name="points"
                        value={formik.values.points}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.points && formik.touched.points && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.points}
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="d-flex justify-content-between">
                        <label>Points UOM</label>
                        <div
                          onClick={handleUomShow}
                          className="addCategoryText"
                        >
                          Add UOM
                        </div>
                      </div>
                      <select
                        onChange={formik.handleChange}
                        name="points_uom"
                        value={formik.values.points_uom}
                      >
                        <option value={""} selected disabled>
                          Select
                        </option>

                        {uomDropdown.length > 0 ? (
                          uomDropdown.map((uom) => (
                            <option value={uom.name}>{uom.name}</option>
                          ))
                        ) : (
                          <option>Data not available</option>
                        )}
                      </select>
                      {formik.errors.points_uom &&
                        formik.touched.points_uom && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.points_uom}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>Percentage</label>
                      <input
                        type="text"
                        placeholder="Enter Percentage"
                        name="percentage"
                        value={formik.values.percentage}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.percentage &&
                        formik.touched.percentage && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.percentage}
                          </div>
                        )}
                    </div>
                    <div>{""}</div>
                  </div>
                  <div className="addModalTextGrid">
                    <div>
                      <label>Description</label>
                    </div>
                    <div>
                      <textarea
                        placeholder="Type here"
                        rows={4}
                        name="description"
                        values={formik.values.description}
                        onChange={formik.handleChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="addModalTextGrid">
                    <div>
                      <label>Additional Notes</label>
                    </div>
                    <div>
                      <textarea
                        placeholder="Type here"
                        rows={4}
                        name="additional_notes"
                        values={formik.values.additional_notes}
                        onChange={formik.handleChange}
                      ></textarea>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    className="addBtnCancel"
                    type="button"
                    onClick={handleAddClose}
                  >
                    Cancel
                  </button>
                  <button className="addBtnSave" type="submit">
                    {" "}
                    Save Product
                  </button>
                </Modal.Footer>
              </form>
            </Modal>
          </div>
          {/* edit product modal  */}
          <div>
            <Modal
              show={editshow}
              onHide={handleEditClose}
              centered
              size="lg"
              className="addModal"
            >
              <form onSubmit={editformik.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title className="addModalTitle">
                    Edit Product
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Product Image <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        name="product_image"
                        accept=".png,.jpg,.jpeg"
                        onChange={(e) =>
                          editformik.setFieldValue(
                            "product_image",
                            e.currentTarget.files[0],
                          )
                        }
                      />
                      {editformik.errors.product_image &&
                        editformik.touched.product_image && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.product_image}
                          </div>
                        )}

                      {/* image preview  */}
                      {previews.product_image && (
                        <img
                          src={previews.product_image}
                          alt="Preview"
                          className="mt-3"
                          style={{ width: "80px", objectFit: "contain" }}
                        />
                      )}
                    </div>
                    <div>
                      <label>Additional Images (add up to 3)</label>
                      <input
                        type="file"
                        name="upload_image"
                        multiple
                        accept=".png,.jpg,.jpeg"
                        // onChange={(e) => {
                        //   const files = Array.from(e.currentTarget.files);

                        //   formik.setFieldValue("upload_image", files);
                        //   console.log("Selected files:", files);
                        // }}
                        onChange={(e) => {
                          const newFiles = Array.from(e.currentTarget.files);
                          const existingFiles =
                            editformik.values.upload_image || [];

                          const combinedFiles = [...existingFiles, ...newFiles];

                          //  does not allow 4th image
                          if (combinedFiles.length > 3) {
                            editformik.setTouched("upload_image", true);
                            editformik.setErrors(
                              "upload_image",
                              "You can upload a maximum of 3 images",
                            );
                            e.target.value = "";
                            return;
                          }

                          // clear error if valid
                          editformik.setFieldError("upload_image", undefined);
                          editformik.setFieldValue(
                            "upload_image",
                            combinedFiles,
                          );
                          e.target.value = "";
                        }}
                      />
                      {/* show preview on file changes  */}
                      {/* {Array.isArray(editformik.values.upload_image) &&
                        editformik.values.upload_image.length > 0 && (
                          <div>
                            {editformik.values.upload_image.map(
                              (file, index) => (
                                <img
                                  key={index}
                                  src={URL.createObjectURL(file)}
                                  width={80}
                                  className="mt-3 me-3"
                                />
                              ),
                            )}
                          </div>
                        )} */}
                      {/* api existing images preview  */}
                      {/* {Array.isArray(additionPreviews.images) &&
                        additionPreviews.images.length > 0 && (
                          <div className="d-flex gap-2 flex-wrap mt-2">
                            {additionPreviews.images.map((img, index) => (
                              <img
                                key={index}
                                src={img.image}
                                width={80}
                                style={{ objectFit: "contain" }}
                              />
                            ))}
                          </div>
                        )} */}

                      {/* new images preview (user selected) */}
                      {Array.isArray(editformik.values.upload_image) &&
                      editformik.values.upload_image.length > 0 ? (
                        <div>
                          {editformik.values.upload_image.map((file, index) => (
                            <img
                              key={index}
                              src={URL.createObjectURL(file)}
                              width={80}
                              className="mt-3 me-3"
                              alt="New preview"
                            />
                          ))}
                        </div>
                      ) : (
                        /* existing images preview (API) */
                        Array.isArray(additionPreviews.images) &&
                        additionPreviews.images.length > 0 && (
                          <div className="d-flex gap-2 flex-wrap mt-2">
                            {additionPreviews.images.map((img, index) => (
                              <img
                                key={index}
                                src={img.image}
                                width={80}
                                style={{ objectFit: "contain" }}
                                alt="Existing preview"
                              />
                            ))}
                          </div>
                        )
                      )}

                      {editformik.errors.upload_image &&
                        editformik.touched.upload_image && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.upload_image}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Product Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Product Name"
                        name="product_name"
                        value={editformik.values.product_name}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.product_name &&
                        editformik.touched.product_name && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.product_name}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>Color</label>
                      <input
                        type="text"
                        placeholder="Enter Color"
                        name="color"
                        value={editformik.values.color}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Product Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Product Code"
                        name="product_code"
                        value={editformik.values.product_code}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.product_code &&
                        editformik.touched.product_code && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.product_code}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>Variant</label>
                      <select
                        onChange={editformik.handleChange}
                        name="variant"
                        value={editformik.values.variant}
                      >
                        <option value={""} selected disabled>
                          Select Variant
                        </option>

                        {variantDropdown.length > 0 ? (
                          variantDropdown.map((variant, index) => (
                            <option key={index} value={variant.code}>
                              {variant.code}
                            </option>
                          ))
                        ) : (
                          <option disabled>Data not available</option>
                        )}
                      </select>
                      {editformik.errors.variant &&
                        editformik.touched.variant && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.variant}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="addModalGrid">
                    <div>
                      <div className="d-flex justify-content-between">
                        <label>
                          Category <span className="text-danger">*</span>
                        </label>
                      </div>
                      <select
                        onChange={editformik.handleChange}
                        name="category"
                        value={editformik.values.category}
                      >
                        <option value={""}>Select Category</option>
                        {categoryDropdown.length > 0 ? (
                          categoryDropdown.map((cat) => (
                            <option value={cat.name}>{cat.name}</option>
                          ))
                        ) : (
                          <option>Data not available</option>
                        )}
                      </select>
                      {editformik.errors.category &&
                        editformik.touched.category && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.category}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>Min Stock Level</label>
                      <input
                        type="number"
                        placeholder="Enter min stock level"
                        name="min_stock_level"
                        value={editformik.values.min_stock_level}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Default Cost Price (MRP)(₹){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Enter Price"
                        name="default_cost_price"
                        value={editformik.values.default_cost_price}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.default_cost_price &&
                        editformik.touched.default_cost_price && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.default_cost_price}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>
                        Sub-distributor Selling Price{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Enter Selling Price"
                        name="subdistributor_selling_price"
                        value={editformik.values.subdistributor_selling_price}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.subdistributor_selling_price &&
                        editformik.touched.subdistributor_selling_price && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.subdistributor_selling_price}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>
                        Retail Selling Price{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Enter Selling Price"
                        name="retail_selling_price"
                        value={editformik.values.retail_selling_price}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.retail_selling_price &&
                        editformik.touched.retail_selling_price && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.retail_selling_price}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>
                        Unit of Measure <span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={editformik.handleChange}
                        name="uom"
                        value={editformik.values.uom}
                      >
                        <option>Select UOM</option>
                        <option value={"lts"}>lts</option>
                        <option value={"kgs"}>kgs</option>
                        <option value={"grm"}>grms</option>
                      </select>
                      {editformik.errors.uom && editformik.touched.uom && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.uom}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>ISI Code</label>
                      <input
                        type="text"
                        placeholder="Enter ISI Code"
                        name="isi_code"
                        value={editformik.values.isi_code}
                        onChange={editformik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Package Size</label>
                      <input
                        type="text"
                        placeholder="Enter Package Size"
                        name="package_size"
                        value={editformik.values.package_size}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>HS Code</label>
                      <input
                        type="text"
                        placeholder="Enter HS Code"
                        name="hs_code"
                        value={editformik.values.hs_code}
                        onChange={editformik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Features</label>
                      <input
                        type="text"
                        placeholder="Enter Features"
                        name="features"
                        value={editformik.values.features}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.features &&
                        editformik.touched.features && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.features}
                          </div>
                        )}
                    </div>
                    {/* <div>
                      <label>Transportation Cost</label>
                      <input
                        type="text"
                        placeholder="Enter Transportation Cost"
                        name="retail"
                        value={editformik.values.retail}
                        onChange={editformik.handleChange}
                      />
                    </div> */}
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>Points</label>
                      <input
                        type="text"
                        placeholder="Enter Points"
                        name="points"
                        value={editformik.values.points}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.points &&
                        editformik.touched.points && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.points}
                          </div>
                        )}
                    </div>
                    <div>
                      <div>
                        <label>Points UOM</label>
                      </div>
                      <select
                        onChange={editformik.handleChange}
                        name="points_uom"
                        value={editformik.values.points_uom}
                      >
                        <option value={""} selected disabled>
                          Select
                        </option>

                        {uomDropdown.length > 0 ? (
                          uomDropdown.map((uom) => (
                            <option value={uom.name}>{uom.name}</option>
                          ))
                        ) : (
                          <option>Data not available</option>
                        )}
                      </select>
                      {editformik.errors.points_uom &&
                        editformik.touched.points_uom && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.points_uom}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>Percentage</label>
                      <input
                        type="text"
                        placeholder="Enter Percentage"
                        name="percentage"
                        value={editformik.values.percentage}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.percentage &&
                        editformik.touched.percentage && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.percentage}
                          </div>
                        )}
                    </div>
                    <div>{""}</div>
                  </div>
                  <div className="addModalTextGrid">
                    <div>
                      <label>Description</label>
                    </div>
                    <div>
                      <textarea
                        placeholder="Type here"
                        rows={4}
                        name="description"
                        value={editformik.values.description}
                        onChange={editformik.handleChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="addModalTextGrid">
                    <div>
                      <label>Additional Notes</label>
                    </div>
                    <div>
                      <textarea
                        placeholder="Type here"
                        rows={4}
                        name="additional_notes"
                        value={editformik.values.additional_notes}
                        onChange={editformik.handleChange}
                      ></textarea>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    className="addBtnCancel"
                    type="button"
                    onClick={handleEditClose}
                  >
                    Cancel
                  </button>
                  <button className="addBtnSave" type="submit">
                    {" "}
                    Update Changes
                  </button>
                </Modal.Footer>
              </form>
            </Modal>
          </div>
          {/* category add modal  */}
          <div>
            <Modal
              show={categoryshow}
              onHide={handleCategoryClose}
              centered
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Add New Category
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="categoryModalGrid">
                  <div>
                    <label>Category Name</label>
                    <input
                      type="text"
                      placeholder="Enter Category Name"
                      name="newCategory"
                      value={newCategory}
                      onChange={(e) => setNewCategory(e.target.value)}
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="addBtnCancel"
                  type="button"
                  onClick={handleCategoryClose}
                >
                  Cancel
                </button>
                <button
                  className="addBtnSave"
                  type="submit"
                  onClick={handleCategorySubmit}
                >
                  {" "}
                  Save
                </button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* variant add modal  */}
          <div>
            <Modal
              show={variantshow}
              onHide={handleVariantClose}
              centered
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Add New Variant
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="categoryModalGrid">
                  <div>
                    <label>Variant Name</label>
                    <input
                      type="text"
                      placeholder="Enter Variant Name"
                      name="newVariant"
                      value={newVariant}
                      onChange={(e) => setNewVariant(e.target.value)}
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="addBtnCancel"
                  type="button"
                  onClick={handleVariantClose}
                >
                  Cancel
                </button>
                <button
                  className="addBtnSave"
                  type="submit"
                  onClick={handleVariantSubmit}
                >
                  {" "}
                  Save
                </button>
              </Modal.Footer>
            </Modal>
          </div>
          {/* uom add modal  */}
          <div>
            <Modal
              show={uomshow}
              onHide={handleUomClose}
              centered
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">Add New UOM</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="categoryModalGrid">
                  <div>
                    <label>UOM Name</label>
                    <input
                      type="text"
                      placeholder="Enter UOM Name"
                      name="newUom"
                      value={newUom}
                      onChange={(e) => setNewUom(e.target.value)}
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="addBtnCancel"
                  type="button"
                  onClick={handleUomClose}
                >
                  Cancel
                </button>
                <button
                  className="addBtnSave"
                  type="submit"
                  onClick={handleUomSubmit}
                >
                  {" "}
                  Save
                </button>
              </Modal.Footer>
            </Modal>
          </div>
          {/* all products and low products delete modal  */}
          <Modal
            show={deleteshow}
            onHide={handleDeleteClose}
            centered
            className="paymentModal"
          >
            <Modal.Header closeButton style={{ borderBottom: "none" }}>
              {/* <Modal.Title>Cancel Order</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <div className="cancelOrderTitle">
                Are you sure want to delete ?
              </div>

              <div className="cancelOrderBtnContainer">
                <div className="paymentBtnCancel">
                  <button onClick={handleDeleteClose}>Close</button>
                </div>
                <div className="paymentBtnConfirm">
                  <button onClick={handleDeleteProduct}>Delete</button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          {/* ref wise table delete modal  */}
          <Modal
            show={deleteStockshow}
            onHide={handleDeleteStockClose}
            centered
            className="paymentModal"
          >
            <Modal.Header closeButton style={{ borderBottom: "none" }}>
              {/* <Modal.Title>Cancel Order</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <div className="cancelOrderTitle">
                Are you sure want to delete stock?
              </div>

              <div className="cancelOrderBtnContainer">
                <div className="paymentBtnCancel">
                  <button onClick={handleDeleteStockClose} type="button">
                    Close
                  </button>
                </div>
                <div className="paymentBtnConfirm">
                  <button onClick={handleDeleteStock}>Delete</button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
